import React from 'react';

import { PlanSettingsContext } from '../PlanSettingsContext';

export const useSettings = () => {
  const {
    meta,
    metricTypes,
    api: { onChangeMetrics, onSwitchReBudget },
  } = React.useContext(PlanSettingsContext);

  return {
    meta,
    metricTypes,
    onChangeMetrics,
    onSwitchReBudget,
  };
};
